var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        title: "订单管理-" + (_vm.initDetail.tagName || ""),
        size: "80%",
        direction: "rtl",
        visible: _vm.visibleDrawer,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visibleDrawer = $event
        },
      },
    },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-form",
                {
                  attrs: { inline: "", size: "small", "label-width": "100px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品分类" } },
                    [
                      _c("el-cascader", {
                        staticClass: "selWidth mr20",
                        attrs: {
                          options: _vm.merCateList,
                          props: _vm.props,
                          clearable: "",
                          size: "small",
                        },
                        on: { change: _vm.handerSearch },
                        model: {
                          value: _vm.listPram.categoryId,
                          callback: function ($$v) {
                            _vm.$set(_vm.listPram, "categoryId", $$v)
                          },
                          expression: "listPram.categoryId",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单时间" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "selWidth mr20",
                        staticStyle: { width: "300px" },
                        attrs: {
                          "value-format": "yyyy-MM-dd",
                          type: "daterange",
                          "range-separator": "-",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                        },
                        on: { change: _vm.handerSearch },
                        model: {
                          value: _vm.listPram.dateRange,
                          callback: function ($$v) {
                            _vm.$set(_vm.listPram, "dateRange", $$v)
                          },
                          expression: "listPram.dateRange",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单状态" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { clearable: "", placeholder: "订单状态" },
                          on: { change: _vm.handerSearch },
                          model: {
                            value: _vm.listPram.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "status", $$v)
                            },
                            expression: "listPram.status",
                          },
                        },
                        _vm._l(_vm.typeOpetion, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单编号" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "selWidth mr20",
                          attrs: {
                            placeholder: "请输入订单编号",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.listPram.orderNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "orderNo", $$v)
                            },
                            expression: "listPram.orderNo",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              slot: "append",
                              icon: "el-icon-search",
                              size: "small",
                            },
                            on: { click: _vm.handerSearch },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "SKU编码" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "selWidth mr20",
                          attrs: {
                            placeholder: "请输入SKU编码",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.listPram.skuCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "skuCode", $$v)
                            },
                            expression: "listPram.skuCode",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              slot: "append",
                              icon: "el-icon-search",
                              size: "small",
                            },
                            on: { click: _vm.handerSearch },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "SPU名称" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "请输入SPU名称",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.listPram.spuName,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "spuName", $$v)
                            },
                            expression: "listPram.spuName",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              slot: "append",
                              icon: "el-icon-search",
                              size: "small",
                            },
                            on: { click: _vm.handerSearch },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "orderNo",
                  label: "订单编号",
                  "min-width": "160",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "statusName",
                  label: "订单状态",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "skuName",
                  label: "SKU名称",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "skuCode",
                  label: "SKU编码",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "categoryName",
                  label: "分类",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "supplierName",
                  label: "供应商",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "180",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handlerDelete(scope.row.orderNo)
                              },
                            },
                          },
                          [_vm._v("移除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }